import * as Yup from 'yup'
import { REFERRAL_TYPES } from '../../../shared/constants/paroReferrals'
import { getItemTypeValues } from '../_local/service'

const referrerTypes = getItemTypeValues(REFERRAL_TYPES)

export const validationSchema = Yup.object({
  zipCode: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().length(5).required('A valid zip code is Required').min(5),
  }),
  paroReferrer: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().min(3).max(39).oneOf(referrerTypes).required('Required') }),
  address1: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().required('Required').min(5).max(95, 'Your Address must be fewer than 95 characters'),
  }),
  phone: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string()
      .length(10, 'Please enter a 10-digit phone number, digits only. Ex: 0123456789')
      .required('Required'),
  }),
  city: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().min(1).required('Required'),
  }),
  region: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().min(2).required('Required'),
  }),
  referrerOther: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().when('paroReferrer', {
      is: 'OTHER',
      then: Yup.string().max(100, 'Must be 100 characters or less').required('Required'),
      otherwise: Yup.string().notRequired(),
    }),
  }),
})
